export var KEY_PREFIX = 'reduxPersist:';
export var REHYDRATE = 'persist/REHYDRATE';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist/es/constants.js
// module id = 441
// module chunks = 25